<footer class="lato privacy-policy-footer mb-4">
  <div>
    <div class="footer-links">
      <a
        class="link"
        href="https://www.campbowwow.com/privacy-policy/"
        target="_blank"
      >
        Privacy & Security
      </a>
      <span class="black"> | </span>
      <a
        class="link"
        href="https://www.campbowwow.com/terms-of-use/"
        target="_blank"
      >
        Terms of Use
      </a>
      <span class="black"> | </span>
      <a
        class="link"
        href="https://www.campbowwow.com/accessibility/"
        target="_blank"
      >
        Accessibility
      </a>
    </div>
    <div class="black">
      Copyright &copy;{{ copyrightYear }} Camp Bow Wow<sup>&#174;</sup>. All rights reserved. Version {{versionInfo}}
    </div>
  </div>
</footer>
